// extracted by mini-css-extract-plugin
export default {"search":"MatrixComboBox_search__qYlLU"};